import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_ARTICLES,
  DELETE_ARTICLE,
  // SEARCH_CONTENT,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { EnhancedTableStatusCell } from "@vocollege/components";
// import VoGroups from "@vocollege/app/dist/modules/VoGroups";

export default function Articles() {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/content/articles/${id}`);
  };

  const getFilters = () => {
    return [
      {
        name: "status",
        label: I18n.get.form.labels.status,
        default: ["all"],
        values: [
          { label: I18n.get.actions.showAll, value: "all" },
          { label: I18n.get.status.published, value: "1" },
          { label: I18n.get.status.unpublished, value: "0" },
        ],
      },
    ];
  };

  return (
    <Layout>
      <EnhancedTable
        className="vo-global__top-bottom-space"
        // enableSearch={Boolean(!VoGroups.getCurrent())}
        enableSearch
        title={I18n.get.misc.articles}
        operations={{
          category: "articles",
          get: GET_ARTICLES,
          delete: DELETE_ARTICLE,
          // search: SEARCH_CONTENT,
          // searchCategory: "searchContent",
        }}
        // querySearchVariables={{
        //   types: ["article"],
        //   entity: true,
        //   limit: 100,
        // }}
        labels={{
          deleted: I18n.get.article.messages.articleDeleted,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.form.labels.title, field: "title" },
          { title: I18n.get.form.labels.date, field: "date" },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
          {
            title: I18n.get.form.labels.status,
            field: "status",
            width: 120,
            render: (data: any) => (
              <EnhancedTableStatusCell data={data.status} />
            ),
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        filters={getFilters()}
      />
    </Layout>
  );
}
